import { Module } from '@nestjs/common';
import { AssetsPoService } from './assets-po.service';
import { AssetsPoController } from './assets-po.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AssetsPoRepository } from './dto/assets-po-repository';
import { AssetsPo } from './assets-po-entity';
import { AssetsPoAdapter } from './dto/assets-po-adpater';
import { VendorsService } from 'libs/shared-services/masters/src/lib/vendors.services';
import { PaymentTermsService } from 'libs/shared-services/masters/src/lib/payment-terms.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: [
    TypeOrmModule.forFeature([AssetsPo,AssetsPoRepository]),
  ],
  providers: [AssetsPoService,AssetsPoAdapter,ApplicationExceptionHandler,VendorsService,PaymentTermsService],
  controllers: [AssetsPoController]
})
export class AssetsPoModule {}
